<template>
  <div class="left-layout" :class="{show: show}" ref="layout">
    <span @click="hideLeft" class="hideLeft">
      关闭
      <i class="iconfont icon-guanbi"></i>
    </span>
    <div class="left-content">
      <component :is="cp" :params="args" />
    </div>
  </div>
</template>

<script>
import mediaInfo from '@/page/information/news/details'

export default {
  data () {
    return {
      cp: '',
      args: {},
      show: false
    }
  },
  methods: {
    showLeft (cp, args) {
      this.cp = cp
      this.args = args
      this.show = true
      this.$bus.$emit('showMask', 1000)
    },
    hideLeft () {
      this.show = false
      this.$bus.$emit('hideMask', 1000)
    }
  },
  mounted () {
    this.$bus.$on('showLeft', this.showLeft.bind(this))
    this.$bus.$on('hideLeft', this.hideLeft.bind(this))

    this.$refs.layout.addEventListener('transitionend', () => {
      if (!this.show) {
        this.cp = ''
        this.args = {}
      }
    })
  },
  components: {
    mediaInfo
  }
}
</script>

<style>
.left-layout {
  position: fixed;
  transform: translateX(-100%);
  top: 0;
  bottom: 0;
  background-color: #fff;
  width: 50%;
  min-width: 600px;
  z-index: 1001;
  transition: transform .5s cubic-bezier(.77, 0, .175, 1);
  padding-top: 20px;
}

.left-layout.show {
  transform: translateX(0);
}

.left-content {
  overflow-y: scroll;
  height: 100%;
}

.hideLeft {
  position: absolute;
  right: 40px;
  top: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/page/layout/left.vue